/**
 * Le message d'une erreur, quelle que soit la chose qui a été levée.
 *
 * `catch` donne un `unknown` : rien ne garantit qu'on attrape une `Error`.
 * Lire `err.message` sans regarder oblige à un `any` qui ment, et affiche
 * « undefined » le jour où quelqu'un lève une chaîne ou un objet nu.
 */
export const messageOf = (error: unknown): string =>
  error instanceof Error ? error.message : String(error);
